import apiConfig from "../../../config/apiConfig";

function getSessionId() {
  try {
    const key = "ads_session_id";
    const existing = localStorage.getItem(key);
    if (existing) {
      return existing;
    }

    const generated = `sess_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(key, generated);
    return generated;
  } catch (error) {
    return undefined;
  }
}

function normalizeAdId({ adId, href = "", imageSrc = "" }) {
  if (adId && String(adId).trim()) {
    return String(adId).trim();
  }

  const key = `${href}|${imageSrc}`.toLowerCase();
  return (
    key
      .replace(/https?:\/\//g, "")
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "")
      .slice(0, 80) || "ad_unknown"
  );
}

export function trackAdClick({
  slotKey,
  adId,
  href,
  imageSrc,
  placement,
  extra = {},
}) {
  const trackingBaseUrl = apiConfig.endpoints.adsService.baseURL || "";
  const trackingEndpoint = trackingBaseUrl
    ? `${trackingBaseUrl.replace(/\/+$/, "")}${apiConfig.endpoints.adsService.routes.trackClick}`
    : "";

  if (!trackingEndpoint) {
    return;
  }

  const payload = {
    slotKey: slotKey || undefined,
    adId: normalizeAdId({ adId, href, imageSrc }),
    targetUrl: href,
    placement,
    pageUrl: typeof window !== "undefined" ? window.location.href : undefined,
    pagePath: typeof window !== "undefined" ? window.location.pathname : undefined,
    sessionId: getSessionId(),
    ...extra,
  };

  console.info("[ads] track click", {
    endpoint: trackingEndpoint,
    slotKey: payload.slotKey,
    adId: payload.adId,
  });

  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([JSON.stringify(payload)], {
        type: "application/json",
      });
      navigator.sendBeacon(trackingEndpoint, blob);
      return;
    }
  } catch (error) {
  }

  fetch(trackingEndpoint, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => { });
}
